import { render, staticRenderFns } from "./SiteDetail.vue?vue&type=template&id=df05613c&scoped=true"
import script from "./SiteDetail.vue?vue&type=script&lang=js"
export * from "./SiteDetail.vue?vue&type=script&lang=js"
import style0 from "./SiteDetail.vue?vue&type=style&index=0&id=df05613c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df05613c",
  null
  
)

export default component.exports